/**
 * Centralised client-side error logging.
 * Never swallow errors silently: at minimum, log them with context so they
 * can be diagnosed in the browser console / monitoring tools.
 */
export function logError(context, error) {
  const detail = error?.response?.data?.detail;
  const message = typeof detail === 'string' ? detail : error?.message || String(error);
  // eslint-disable-next-line no-console
  console.error(`[ptitservices] ${context}:`, message, error?.response?.status ? `(HTTP ${error.response.status})` : '');
  return message;
}

/** Convenience for optional/non-blocking fetches: `.catch(swallowWithLog('team'))` */
export const swallowWithLog = (context) => (error) => logError(context, error);
